import { PatientProfileEffects as Effects } from './patient-profile.effects';

export const PatientProfileEffects = [Effects];
